import { Provider } from '@angular/core';
import { ServiceApiService } from './data-access/service-api.service';
import { ServiceRequestApiService } from './data-access/service-request-api.service';
import { ServiceOfferService } from './services/service-offer.service';
import { ServiceRequestService } from './services/service-request.service';

export const SERVICES_PROVIDERS: Provider[] = [
  ServiceApiService,
  ServiceOfferService,
  ServiceRequestApiService,
  ServiceRequestService,
];
